<div class="container funnel">
  <div class="d-flex justify-content-center mt-5 w-40 m-auto">
    <div class="text-center">
      <img src="assets/images/logo.svg" alt="logo" width="120" class="mb-3" />
      <h2>Thank you!</h2>
      <p>Someone from Wellness will contact you soon.</p>
    </div>
  </div>
</div>


